import _ from "lodash";
import * as React from "react";
import { useMappedState } from "redux-react-hook";

import { useDrop } from "src/core/drops/hooks";
import { IStore } from "src/core/shared/store";
import {
  useCallOffApi,
  ICallOff
} from "src/modules/call-off/api/call-off.api";

export const CallOffsContext = React.createContext<{ callOffs: ICallOff[], isLoading: boolean }>({
  callOffs: [],
  isLoading: false
});

export const CallOffsProvider: React.ReactFCWithChildren = props => {
  const [ getCallOffRes, getCallOffs ] = useCallOffApi("LIST_CUSTOMER_CALL_OFFS");
  const installedModules = useMappedState((store: IStore) => store.global.settings?.installedModules || []);
  const [ currentCallOffs, setCurrentCallOffs ] = React.useState<ICallOff[]>([]);
  const [ { drop } ] = useDrop();

  React.useEffect(() => {
    if (!installedModules.includes("call-off")) {
      return;
    }

    if (drop?.customerId) {
      getCallOffs({ customerId: drop.customerId });
    }
  }, [
    drop?.customerId,
    getCallOffs,
    installedModules
  ]);

  React.useEffect(() => {
    if (!installedModules.includes("call-off")) {
      return;
    }

    if (getCallOffRes.data && _.find(getCallOffRes.data, co => co.customerId === drop?.customerId)) {
      setCurrentCallOffs(getCallOffRes.data || []);
    } else {
      setCurrentCallOffs([]);
    }
  }, [
    drop?.customerId,
    getCallOffRes.data,
    installedModules
  ]);

  return (
    <CallOffsContext.Provider
      value={{
        callOffs: currentCallOffs,
        isLoading: getCallOffRes.pending
      }}
    >
      {props.children}
    </CallOffsContext.Provider>
  );
};
